// removed by extract-text-webpack-plugin
module.exports = {"marketGroup":"_3cgOJrW46jIbx7j8Cfw6Y9","marketType":"_1LUTMkBg_20oiWcRD0dRK8","scoreGroup":"_2H7KX0uPvhotROsdt7mGu1","marketText":"_1tArN9P7Z2Spl3ZX4XRlZo","oddsButton":"_7_b9qBKRdRgG_druz6REi"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/markets.css
// module id = 32
// module chunks = 0